import type { MultiselectAutocompleteOption } from 'design-system/src/components/MultiselectAutocomplete/MultiselectAutocomplete';
import { STATES } from 'design-system/src/sharedConstants';

// The string used to separate multiple selections of a single category when combined
// into a string, for example in the url search params.
// No escaping is required for the '|' delimiter.
// Keep in sync with python/partner_portal/rx_table_query.py
export const MULTI_SELECT_DELINEATOR = '|';

export const DRUG_CATEGORY_DROPDOWN_OPTIONS: MultiselectAutocompleteOption[] = [
  { description: 'Biologic', value: 'biologic' },
  { description: 'Non-Biologic', value: 'non_biologic' },
  { description: 'Provider-Administered', value: 'provider_administered' },
];

export const STATUS_DROPDOWN_OPTIONS: MultiselectAutocompleteOption[] = [
  { description: 'PA in progress', value: 'in_progress' },
  { description: 'PA submitted', value: 'pa_submitted' },
  { description: 'Approved', value: 'approved' },
  { description: 'Denied', value: 'denied' },
  { description: 'Appeal submitted', value: 'appeal_submitted' },
  { description: 'PA not required', value: 'pa_not_required' },
];

export const EMAIL_VALIDATION_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const DUPLICATE_EMAIL_ERROR = 'A user with this email has already been added.';

/** Minimum number of characters required before triggering a table search */
export const MIN_SEARCH_LENGTH = 2;

// NOTE: keep this in sync with the constant in python/partner_portal/blueprints/provider_signup.py
export const PHONE_VALIDATION_REGEX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

export const PROVIDER_SUPPORT_CONTACT_INFO = {
  phone: '(208) 254-0103',
  email: 'provider-support@withtandem.com',
};

export const TANDEM_PHARMACY_INFO = {
  name: 'Tandem Access Support',
  address: '1020 W Main St #100C, Boise, ID 83702',
  ncpdp: '1310844',
};
export const TANDEM_HOMEPAGE_URL = 'https://withtandem.com';
export const TANDEM_PATIENTS_URL = `${TANDEM_HOMEPAGE_URL}/patients`;

// The fax number used to send CMM fax verification to the prescriber
export const TANDEM_CMM_FAX_NUMBER = '877-745-8562';

// Example CMM fax verification shown as reference to the user
export const CMM_VERIFICATION_EXAMPLE_URL =
  'https://public-cmm-verification-example.s3.amazonaws.com/CMMFaxVerificationExample.pdf';

export const DOB_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const currentYear = new Date().getFullYear();
// as of the time of writing, the oldest person alive was born in 1908
export const DOB_YEARS = Array.from({ length: currentYear - 1908 + 1 }, (_, i) => currentYear - i);
// TODO: get the number of days in the month instead of hardcoding to 31
export const DOB_DAYS = Array.from({ length: 31 }, (_, i) => i + 1);

export const stateNames = [...Object.values(STATES)] as const;
export type StateName = (typeof stateNames)[number];

// Specialties that can book a demo and set up an account on their own.
export const FULLY_SUPPORTED_SPECIALTIES = [
  'allergy_and_immunology',
  'dermatology',
  'endocrinology',
  'gastroenterology',
  'hepatology',
  'neurology',
  'pulmonology',
  'rheumatology',
  'urology',
] as const;

// Specialties that can book a demo but cannot set up an account on their own.
// NOTE: As of 03/09/26 is used only in unit tests just to verify each specialty is accounted for.
export const DEMO_ONLY_SPECIALTIES = ['oncology', 'pediatrics', 'multi_specialty', 'other'] as const;

// Specialties that cannot book a demo or set up an account on their own.
export const UNSUPPORTED_SPECIALTIES = [
  'cardiology',
  'internal_medicine',
  'obstetrics_and_gynecology',
  'ophthalmology',
  'primary_care',
  'psychiatry',
  'none',
] as const;
